import Numbers from '@mui/icons-material/Numbers';
import { s } from '../../format/schema';
import { defineFieldType } from '../card';
import { NumberStepperInput } from './FillInput';
import { NumberStepperSettingsPanel } from './SettingsPanel';
import { numberStepperSettings } from './settings';

export const numberStepper = defineFieldType({
  type: 'numberStepper',
  name: 'Number stepper',
  valueKind: 'number',
  settings: numberStepperSettings,
  defaults: { step: 1, integerOnly: false },
  value: s.number().nullable(),
  emptyValue: null,
  hasDefaultValue: true,
  validations: ['required', 'range', 'unique'],
  operators: [
    'isFilled',
    'isEmpty',
    'equals',
    'notEquals',
    'lessThan',
    'lessThanOrEqual',
    'greaterThan',
    'greaterThanOrEqual',
  ],
  palette: [
    {
      name: 'Number stepper',
      tooltip: 'A number with − and + buttons',
      group: 'Number, date and file',
      icon: Numbers,
    },
  ],
  isEmpty: value => value === null,
  quantity: value => value,
  comparable: value => (Number.isFinite(value) ? value : Number.NaN),
  builtInCheck: settings => (settings?.integerOnly ? 'wholeNumber' : 'number'),
  FillInput: NumberStepperInput,
  settingsPanel: { at: 'settings', Panel: NumberStepperSettingsPanel },
});
